import React from "react";

import { GameInformationUgcDataType } from "../../../../models/forms";
import { ReadOnlyFormItem } from "../appInfoModelsAndHelpers";
import { ReadOnlyForm } from "../ReadOnlyForm";

type ReadOnlyIdXboxUgcProps = {
  dataInForm: GameInformationUgcDataType;
};

const IdXboxUgcConfig: Map<string, ReadOnlyFormItem> = new Map([
  [
    "ugcDetails",
    {
      title: "describeWhatTheUgcWillBe",
    },
  ],
]);

export const ReadOnlyIdXboxUgc = ({ dataInForm }: ReadOnlyIdXboxUgcProps) => (
  <ReadOnlyForm formConfig={IdXboxUgcConfig} formData={dataInForm} />
);
